var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M11.9983 3.37708V15.2888L17.2458 12.1599L11.9983 3.37708Z",
    fill: "#5B65CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.9993 3.37708L6.75171 12.1599L11.9993 15.2888V9.75398V3.37708Z",
    fill: "#5B65CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M11.9982 16.2906L11.9336 16.37V20.4322L11.9982 20.6225L17.2489 13.1633L11.9982 16.2906Z",
    fill: "#5B65CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.9985 20.623V16.2912L6.75098 13.1639L11.9985 20.623Z",
    fill: "#5B65CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 15.2889L17.246 12.1601L11.9985 9.75421V15.2889Z",
    fill: "#5B65CE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.75098 12.1594L11.9984 15.2882V9.75348L6.75098 12.1594Z",
    fill: "#5B65CE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.44527dc36b491b72e25613c84df525fd.svg";
export { ForwardRef as ReactComponent };